import { useBoundField, type FieldProps } from "../field-state";

export function TextField(props: FieldProps<"s-text-field">) {
  const { field, error, dismissError, handleBlur } = useBoundField<string>();
  return (
    <s-text-field
      {...props}
      name={field.name}
      value={field.state.value}
      error={error}
      onFocus={dismissError}
      onInput={(event) => {
        dismissError();
        field.handleChange(event.currentTarget.value);
      }}
      onBlur={handleBlur}
    />
  );
}
